export const SortableHeader = ({
  column,
  label,
  sortConfig,
  onSort,
  className = "",
}) => {
  const isActive = sortConfig.key === column;

  return (
    <th
      onClick={() => onSort(column)}
      style={{ cursor: "pointer", userSelect: "none" }}
      className={className}
    >
      {label}
      {isActive && (sortConfig.direction === "asc" ? " ▲" : " ▼")}
    </th>
  );
};
